<nav class="navbar-compact bg-white dark:bg-gray-900 fixed w-full top-0 z-50 transition-colors duration-200 border-b border-gray-200 dark:border-gray-800">
 <div class="container mx-auto px-4">
 <div class="flex justify-between items-center gap-4 h-20">
 <!-- Logo -->
 <a routerLink="/" class="logo-link flex items-center gap-2 flex-shrink-0">
 <img src="/assets/images/logo-icon.svg" alt="FarmaFlow" class="w-10 h-10">
 <span class="logo-text text-gray-900 dark:text-white font-black text-xl">FarmaFlow</span>
 </a>

 <!-- Nav Links -->
 <div class="hidden lg:flex items-center gap-1 flex-shrink-0">
 <!-- Theme Toggle -->
 <button 
 (click)="toggleTheme()" 
 class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400"
 [title]="themeService.isDark() ? 'Modo Claro' : 'Modo Escuro'">
 @if (themeService.isDark()) {
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
 </svg>
 } @else {
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
 </svg>
 }
 </button>
 

 @if (!authService.currentUser()) {
 <a routerLink="/para-voce" class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 font-medium"> 
 <span>Para Você</span>
 </a>
 <a routerLink="/para-farmacia" class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 font-medium"> 
 <span>Para Sua Farmácia</span>
 </a>
 <a routerLink="/para-clinica" class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 font-medium"> 
 <span>Para Sua Clínica</span>
 </a>
 <a routerLink="/para-deposito" class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 font-medium"> 
 <span>Para Depósitos</span>
 </a>
 <a routerLink="/para-profissionais" class="nav-link text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 font-medium"> 
 <span>Para Profissionais</span>
 </a>
 }

 @if (authService.currentUser(); as user) {
 @if (user.tipo === 'cliente') {
 <a routerLink="/paciente/dashboard" routerLinkActive="nav-link-active" class="nav-link"> 
 <span>Dashboard</span>
 </a>
 <a routerLink="/paciente/carrinho" class="nav-link relative"> 
 <span>Carrinho</span>
 @if (carrinhoService.quantidade() > 0) {
 <span class="cart-badge">{{ carrinhoService.quantidade() }}</span>
 }
 </a>
 <a routerLink="/paciente/pedidos" routerLinkActive="nav-link-active" class="nav-link">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
 </svg>
 <span>Pedidos</span>
 </a>
 }

 @if (user.tipo === 'farmacia') {
 <a routerLink="/farmacia/dashboard" routerLinkActive="nav-link-active" class="nav-link">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
 </svg>
 <span>Dashboard</span>
 </a>
 <a routerLink="/farmacia/medicamentos" routerLinkActive="nav-link-active" class="nav-link">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
 </svg>
 <span>Medicamentos</span>
 </a>
 <a routerLink="/farmacia/pedidos" routerLinkActive="nav-link-active" class="nav-link">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
 </svg>
 <span>Pedidos</span>
 </a>
 }

 <div class="user-menu">
 <button class="user-button">
 <div class="user-avatar">{{ user.nome.charAt(0).toUpperCase() }}</div>
 <span class="user-name">{{ user.nome.split(' ')[0] }}</span>
 </button>
 </div>
 
 <button (click)="logout()" class="btn-logout">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
 </svg>
 </button>
 } @else {
 <a routerLink="/login" class="nav-link">
 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
 </svg>
 <span>Entrar</span>
 </a>
 <a routerLink="/registro" class="btn-register">
 Registrar
 </a>
 }
 </div>

 <!-- Mobile Menu Button -->
 <button 
 (click)="toggleMobileMenu()"
 class="lg:hidden p-2 text-gray-900 dark:text-gray-100 hover:text-orange-600 dark:hover:text-orange-400 transition-colors">
 @if (!mobileMenuOpen) {
 <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
 </svg>
 } @else {
 <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
 </svg>
 }
 </button>
 </div>


 </div>

 <!-- Mobile Menu -->
 @if (mobileMenuOpen) {
 <div class="lg:hidden border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 animate-slideDown">
 <div class="container mx-auto px-4 py-4 space-y-4">
 <!-- Theme Toggle Mobile -->
 <button 
 (click)="toggleTheme()" 
 class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 @if (themeService.isDark()) {
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
 </svg>
 <span>Modo Claro</span>
 } @else {
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
 </svg>
 <span>Modo Escuro</span>
 }
 </button>
 
 @if (!authService.currentUser()) {
 <a routerLink="/para-voce" (click)="closeMobileMenu()" class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
 </svg>
 <span>Para Você</span>
 </a>
 <a routerLink="/para-farmacia" (click)="closeMobileMenu()" class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
 </svg>
 <span>Para Sua Farmácia</span>
 </a>
 <a routerLink="/para-clinica" (click)="closeMobileMenu()" class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
 </svg>
 <span>Para Sua Clínica</span>
 </a>
 <a routerLink="/para-deposito" (click)="closeMobileMenu()" class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
 </svg>
 <span>Para Depósitos</span>
 </a>
 <a routerLink="/para-profissionais" (click)="closeMobileMenu()" class="mobile-menu-item text-gray-900 dark:text-gray-100 font-medium">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
 </svg>
 <span>Para Profissionais</span>
 </a>
 }

 @if (authService.currentUser(); as user) {
 @if (user.tipo === 'cliente') {
 <a routerLink="/paciente/dashboard" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
 </svg>
 <span>Dashboard</span>
 </a>

 <a routerLink="/paciente/carrinho" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"></path>
 </svg>
 <span>Carrinho</span>
 @if (carrinhoService.quantidade() > 0) {
 <span class="ml-auto bg-red-500 text-white text-xs px-2 py-1 rounded-full">
 {{ carrinhoService.quantidade() }}
 </span>
 }
 </a>

 <a routerLink="/paciente/pedidos" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
 </svg>
 <span>Meus Pedidos</span>
 </a>
 }

 @if (user.tipo === 'farmacia') {
 <a routerLink="/farmacia/dashboard" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
 </svg>
 <span>Dashboard</span>
 </a>

 <a routerLink="/farmacia/medicamentos" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
 </svg>
 <span>Medicamentos</span>
 </a>

 <a routerLink="/farmacia/pedidos" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
 </svg>
 <span>Pedidos</span>
 </a>
 }

 <div class="border-t border-gray-200 dark:border-gray-700 pt-4 mt-4">
 <div class="mobile-menu-item">
 <div class="w-8 h-8 bg-gradient-to-br from-orange-500 to-amber-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
 {{ user.nome.charAt(0).toUpperCase() }}
 </div>
 <span class="font-semibold">{{ user.nome }}</span>
 </div>

 <button (click)="logout(); closeMobileMenu()" class="mobile-menu-item text-red-600 dark:text-red-400">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
 </svg>
 <span>Sair</span>
 </button>
 </div>
 } @else {
 <a routerLink="/login" (click)="closeMobileMenu()" class="mobile-menu-item">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
 </svg>
 <span>Entrar</span>
 </a>

 <a routerLink="/registro" (click)="closeMobileMenu()" class="mobile-menu-item bg-orange-50 dark:bg-orange-900/20 text-orange-600 dark:text-orange-400 font-semibold">
 <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
 </svg>
 <span>Criar Conta</span>
 </a>
 }
 </div>
 </div>
 }
</nav>

<!-- Spacer para compensar navbar fixed - REMOVIDO para home -->
<!-- <div class="h-14"></div> -->
